<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M3.6 16.4V3.6H9.2V16.4H3.6ZM10.8 16.4H16.4V3.6H10.8V16.4ZM2 3C2 2.44772 2.44772 2 3 2H17C17.5523 2 18 2.44772 18 3V17C18 17.5523 17.5523 18 17 18H3C2.44772 18 2 17.5523 2 17V3Z"
          fill="#2E1E51" fill-opacity="0.54"/>
</svg>
